import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { OrganizationVideo } from './useOrganizationVideoQuery';
import { organizationVideoQueryKeys } from './queryKeys';

const updateOrganizationVideo = async (body: Partial<OrganizationVideo>) => {
  return await EXPRESS_API.put(
    `/organization-videos/${body.organizationVideoId}`,
    body
  );
};

export const useUpdateOrganizationVideoMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (body: Partial<OrganizationVideo>) => updateOrganizationVideo(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(organizationVideoQueryKeys.all);
      },
    }
  );
};
